import { createPortal } from 'react-dom'
import { Interactive } from '@highlight/ui'
import { getConeBounds, type Cone } from '../safe-triangle'

/**
 * Registers the cone's corridor as interactive while the pointer crosses it.
 *
 * The overlay is click-through outside Interactive bounds, and
 * `mouse-move-fallback` only injects moves inside them. So the gap between the
 * panel and the card gets no `pointermove` at all, and without this a slow
 * diagonal times out and loses the card.
 *
 * Portaled to the body because the panel animates under a transform, which
 * would become the containing block for a `fixed` child.
 */
export function ConeBridge({ cone }: { cone: Cone }) {
  const { left, top, width, height } = getConeBounds(cone)
  return createPortal(
    <div aria-hidden className="pointer-events-none fixed" style={{ left, top, width, height }}>
      <Interactive />
    </div>,
    document.body,
  )
}
